module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('p', {
    staticClass: "Blurb"
  }, [_vm._v("David Greaves is retired, married and lives in Southwest France. After a career as the Head of Legal Department for an International Company, he has turned his hand to writing books for children. He has various likes, including music, literature, cricket, France and jigsaws.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "Graphics",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035843466_txt3.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "Heading ParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Copyright © David Greaves 2024")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("The right of "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("David Greaves")]), _vm._v(" to be identified as author of this work has been asserted by the author in accordance with sections 77 and 78 of the Copyright, Designs and Patents Act 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("A CIP catalogue record for this title is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("ISBN 9781035843466 (Paperback)")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("ISBN 9781035843473 (ePub e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("www.austinmacauley.com")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("First Published 2024")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Austin Macauley Publishers Ltd®")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 Canada Square ")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Canary Wharf ")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("London")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("E14 5AA")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "Dedi ParaOverride-1"
  }, [_vm._v("For my three grandchildren.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("For Erin and Liam, for whom this began as a bedtime story, and who made some useful contributions over several nights.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("And for Daniel, who will hopefully enjoy the story when he is a bit older.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "Image-on-next-page- ParaOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/1684919901_Rita-interior-V2_(4)_Page_34.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "main-heading"
  }, [_vm._v("Chapter 1")]), _vm._v(" "), _c('p', {
    staticClass: "sub-heading"
  }, [_vm._v("The Nincompoops")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Gordon, how many times have I told you to clean out this stinky bird cage!’ yelled Mrs Nincompoop. ‘This dirty parrot that you bought all those years ago is just not worth the trouble, and either you look after it, or else, it just has to go.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Sorry dear,’ replied Mr Nincompoop, who was upstairs, watching TV, ‘I’ll get to it straight after the golf finishes.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I’ve heard that before,")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" thought Mrs Nincompoop, as she swept her feather duster all over her husband’s study, which looked over their leafy Surrey garden. Reluctantly, she reached into the cage to change the sandpaper flooring and received a quick peck on the wrist for her troubles. ‘You horrible mangy specimen!’ she cursed and went to find a plaster.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Same to you,’ replied the parrot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Back came Mrs Nincompoop, this time with the hoover, and muttering things about Mr Nincompoop as she hoovered. ‘What this place needs is some fresh air,’ she said, as she opened the windows in a huff. ‘And what I need is a nice cup of tea to settle my nerves.’ She shuffled out of her husband’s study, without noticing that his papers were flying out of the window. And without noticing that she had left the door of the birdcage slightly ajar.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("The parrot, whom the Nincompoops had named Mavis, but who somehow knew that her real name was Rita, sat back and rocked herself on her perch. ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Hmmm,")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" she thought, ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("is this my big opportunity to get out of this place? ")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("You see, Rita’s parents had been captured from Africa, illegally, and brought to England ten years ago. So Rita had been born in England, in a tropical bird ‘sanctuary’. Her parents, not quite adapting to the English climate or their imprisonment, had eventually lost hope, and died.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("And Rita had then been purchased by Mr Nincompoop to liven up his study.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Mr Nincompoop had been quite kind, especially at the beginning, but gradually became mainly interested in teaching her to swear, in colourful language, so as to impress his friends. Mrs Nincompoop had never been comfortable about having a tropical bird to deal with. She preferred her fluffy cat, who would gaze up menacingly at Rita when the adults weren’t looking.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("All in all, Rita’s life was not that great, which is what she said to herself, as she noticed the slightly open cage door, and beyond the wide-open French windows. ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Well, she thought, I suppose here I get fed regularly, but it’s not much of a life, being stuck in this cage, having people gawp at me, and expecting me to repeat silly phrases in their own language. There must be more to life than this. ")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("But she was also aware of the dangers of leaving her captivity and shooting out of the window.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('p', {
    staticClass: "Graphics",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-3",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035843466_txt5.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('p', {
    staticClass: "InDent-txt"
  }, [_vm._v("She thought and thought, and then Mrs Nincompoop yelled from the kitchen, ‘Gordon, your parrot has some new yellow and blue feathers that would go nicely in my new hat. Come and hold the bird still while I pluck them!’")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("That was enough. Rita thought that whatever lay outside those windows, could not be worse than spending more time at the mercy of the Nincompoops. So she took a deep breath, pushed her beak at the cage door, and sailed across the room, out through the French windows, and up and up, above the London suburbs. ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Well, now what?")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" she thought, as she looked down on her only home up until now. ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("And it’s cold up here.")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" But just as she thought this, she felt a warmer wind coming from the south, and so by instinct, she set off in that direction.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer011"
    }
  }, [_c('p', {
    staticClass: "Image-on-next-page- ParaOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/1684919901_Rita-interior-V2_(4)_Page_34.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "main-heading"
  }, [_vm._v("Chapter 2")]), _vm._v(" "), _c('p', {
    staticClass: "sub-heading"
  }, [_vm._v("Across the Sea")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rita was by now flying straight into the warm wind, which slowed her down and made her tired. But she kept going, wanting to get as far away from the Nincompoops as quickly as possible. After a while, the sun burst through the clouds, and she started to notice a different, salty smell. Straining her eyes towards the horizon, she saw that the gardens and fields below her were coming to an end, and were followed by the biggest stretch of water that she had ever seen. In fact, she had never seen anything bigger than the duck pond in the Nincompoop’s garden. ‘I’d better find a safe place to land, and have a bit of a think,’ she said to herself. Then she spotted that where the land ended and the water started, there was a wide, empty yellow strip with no people on it. This was important because she needed time to think, and not to be bothered by humans. So she descended slowly and landed on the beach.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("So far, so good,")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" thought Rita, as she spread her feathers out in the sunshine. And no nasty humans in sight, but as she looked around, while there were indeed no humans, there were, in fact, lots and lots of other birds. White, noisy birds, squawking for no obvious reason. Although she didn’t know it, these were seagulls, who were very used to hunting for food on this beach. And suddenly a group of these birds started to approach her, shrieking ever more loudly, as if to say, ‘Get lost, you don’t belong here.’ As the seagulls came closer and closer, squawking louder and louder, Rita quickly decided that she needed to get away, and fast, so she flew up to the top of a cliff and found a ledge where she felt safe. As the noise died down, she heard the flapping of a pair of wings, and all of a sudden, a single seagull landed at her side.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘So sorry, if my family scared you,’ he said. ‘You seem in need of help, especially as you’re not one of us. And if I’m right, you’re far from home, and you must be hungry.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rita wasn’t sure what to say, but, plucking up some courage, said, ‘Well, yes, I am a bit lost and quite hungry, but I think I can look after myself, thank you.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Okay fine,’ said the seagull, ‘but if you want my advice, look out for the big boats travelling between here and the other side of this sea. They’re filled with people who love to eat so much, that they leave bits of food all over the place, and you can just fly down and feast on all the food that they drop.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("This seemed like good advice to Rita, and while she was still a bit unsure about her new ‘friend’ since she was a very polite parrot, she thanked him anyway, saying, ‘Okay, that’s kind of you, but now I need to rest because I have a long way to go tomorrow. See you again sometime, maybe.’ With that, she settled down into a crack in the cliff face, and the seagull set off to rejoin his squawking family.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("After a bit of a rest and a light snooze, Rita spread out her multi-coloured feathers and shook herself up. ‘Right then,’ she said to herself, ‘so far, so good, but now I need to eat something.’ Just at that moment, a loud horn sounded, and she saw a ship moving slowly away, just along the coast where she had landed. ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("That must be what the seagull was talking about, ")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("she thought and started to get ready for her next big flight. So up she went, following the ship, and looking down at its passengers. They were all eating and eating all sorts of stuff; sandwiches, crisps, chips, and that sort of thing. ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Not quite to my taste,")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" thought Rita, ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("but I’m really hungry, and so I’ll take whatever I can get.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("She waited until the humans had moved away from the top deck of the ship – it was a very windy day – and then swooped down to where the humans had been. Sure enough, there were plenty of scraps left all over the deck. ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Well, lucky me,")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" thought Rita,")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" but why don’t these people eat all of their food, instead of dropping it all over the place?")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("She was just enjoying a nice nibble of cheese, when out of the corner of her eye, she spotted a little boy approaching her with a camera, and shouting, ‘Mum, Dad, come quickly, you won’t believe what I’ve found!’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rita wasn’t sure how to react. Should she escape, or should she show off her best feathers? Just as she was thinking how best to pose for a photo, another man came out onto the deck, and he was carrying a net. ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Uh oh, ")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("thought Rita, ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("time to fly.")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" The man with the net started running towards her, and she scarcely had time to spread her wings and soar upwards. But she managed it and looking down, realised what a close call that had been. The man with the net below her looked angry and red-faced. Rita suddenly felt that she’d eaten quite a lot, and she realised that the man with the net could have captured her, and ended her new-found freedom. So, as she was flying away, she dropped a big dollop of parrot poop, exactly on top of his bald head.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer013"
    }
  }, [_c('p', {
    staticClass: "Graphics",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-4",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035843466_txt8.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer015"
    }
  }, [_c('p', {
    staticClass: "Image-on-next-page- ParaOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/1684919901_Rita-interior-V2_(4)_Page_34.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "main-heading"
  }, [_vm._v("Chapter 3")]), _vm._v(" "), _c('p', {
    staticClass: "sub-heading"
  }, [_vm._v("La Belle France")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Feeling quite pleased with herself for having handled her first challenge rather well, Rita continued her journey south. Before very long, she came across a new piece of land, with green fields and little houses, much the same as those she had left behind. She didn’t know it yet, but this was France. Oh dear, she thought to herself, ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I was hoping for somewhere a bit different to where I’ve come from.")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" But as she flew on and on, over the flat and uninspiring countryside, there was nothing to raise her hopes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Then suddenly, just over to her left side, she saw a flock of brown birds, all flying together as a group. ‘Hey, you over there,’ called the bird at the front of the group. ‘We’ve never seen a parrot up here. Where are you heading?’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘I’m not sure,’ replied Rita, ‘just somewhere warmer.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Well, that’s exactly what we’re doing,’ said the brown bird. ‘Why don’t we all take a break, and tell you about our route?’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Yes please,’ Rita replied enthusiastically, ‘that would be very kind of you.’ And so they all swooped down and landed on the upper branches of a forest of trees, just as it began to rain.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Best we all stay here for a few hours,’ advised the brown bird, ‘we have a long journey ahead of us tomorrow, and we all need to find some food, clean our feathers, and get a bit of sleep.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Yes,’ said Rita, ‘but then what? Can you give me some idea of what to expect, and where to go?’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Well, you can follow us for as long as you want,’ responded the brown bird, ‘but my guess is that you really want to go back to where your parents came from, which might just be somewhere in Africa.’ Rita was stunned. This bird had managed to work out exactly what Rita wanted, and now suddenly, she had a purpose. ‘Follow us for a while,’ he added, ‘and then when we turn right towards Spain, you keep going directly south towards Africa, your home.’ This all sounded absolutely perfect to Rita.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Thank you, thank you a hundred times,’ she said, and then there was quietness all around, as the rain stopped, and all the birds dropped their heads and began to sleep.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("The next morning, the sun came up early, and the birds all spread out their feathers to capture its warmth. Rita did the same and soon felt ready to set off with the others on a long journey. After a quick breakfast of nuts and fruit, the whole flock rose up into the sky and turned towards the south. Things were going just fine until they passed over what looked like a big city, with tall buildings, parks, and a twisty river. ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("This looks like a lovely place,")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" thought Rita – it was Paris in fact – and she became a bit distracted and separated from the rest of the flock. The others had flown on, while Rita was taking her time to observe all the beautiful buildings she saw below.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("She thought that she would take some time to have a closer look at this marvellous city, and so swooped down to land on a white arched building in the middle of a big roundabout, with cars zooming all around coming and going in twelve different directions.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘English-speaking bus tour of Paris, leaving here in five minutes!’ a deep voice shouted above the noise of the traffic.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("What a good idea,")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" thought Rita to herself, ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I can sit at the back of the roof, and get to see all the main sights in one afternoon.")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" And that was exactly how it worked out, as the bus took Rita all over the city; from Place de la Concorde to the Louvre; from the Panthéon to Les Invalides, where she jumped off onto the branch of a nearby tree, her head buzzing with all that she’d seen.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("It was early evening now, but just as she was about to resume her flight south, several rockets burst into the sky all around her, showering golden sparks in all directions. How was she to know that she had arrived in Paris on December 31? Just as she thought that the rocket attacks were over, more and more missiles burst all over the sky, exploding into purple, green, and orange sparkles, followed by a huge blast of silver and red. Rita had never seen anything like this, and having overcome her fear of the noise and explosions, she decided to fly up to the top of a tall pointy building that seemed to be at the centre of all these eruptions of light. She sat there quite comfortably and watched the rest of the display. She looked down on all the people below, who were clapping and having a good time. ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Well, this is more like it,")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" thought Rita, and just as she was starting to feel comfortable in her new surroundings, she remembered that she had lost contact with the flock of birds who were migrating south.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Hmmm,")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" she thought, without panicking. ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("They already told me which way to go, so maybe I can manage it by myself.")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" And that’s exactly what she did, spreading her blue and green wings, and shooting off through the fireworks, always heading south towards warmer places. Nothing much happened on the next part of her journey. Just more fields and small houses, but at least she felt safe, and away from danger. She flew and flew until the sun started to go down in the west, and she knew it was time to land. She looked all around her, left and right, and then became aware of some bird noises ahead of her. She decided to go down and investigate because by now, she had become brave and confident.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("But as she landed on the ground, she was still unprepared for what she saw and heard. Yes, there was birdsong of all varieties, but they were all coming from the same place, and there were no birds flying in the sky. Because they were all in cages. True, most of the cages were big and full of all the things that birds like, but they were still closed, with no possibility of escape. Rita was a bit confused. She knew that she had been kept in a cage by the Nincompoops, but why were there so many beautiful birds here altogether? When they should be flying around outside.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("As she approached the cages, she saw a parrot who looked a lot like her, and so she called over, ‘Hey you, what are you doing in this place, and what sort of a place is it exactly?’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Hello, Sister,’ replied the other parrot, ‘I’m really pleased to see you, especially as you look a lot like me. We can have a quick chat, but don’t stay around here too long, in case they capture you, and put you in here with us, in this bird zoo.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Don’t worry about me,’ said Rita, ‘but what about you, trapped in there?’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Oh, it’s not so bad, and by the way, I’m Jules,’ said her new friend. ‘We get fed regularly, the weather is nice, and we have room to fly around and play with our friends. And the humans who look after us are quite kind, well, much better than all the members of the public")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer017"
    }
  }, [_c('p', {
    staticClass: "Graphics",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-5",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035843466_txt11.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer018"
    }
  }, [_c('p', {
    staticClass: "Txt"
  }, [_vm._v("who come to see us every day, and take photo after photo. That’s pretty boring, but it’s better after they’ve all gone home.’")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rita wasn’t sure what to make of this. On the one hand, she thought that all birds like her ought to be free to fly around wherever they wanted, but at least Jules and his friends seemed to be well looked after, and his plumage was bright and healthy-looking. For a minute, she considered offering to peck away at the lock on the outside of the cage so that he and his friends could escape, but then she thought, ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Well, this is just another part of life in the wider world, and I’ve still got a lot more to learn, so perhaps I shouldn’t do anything for now.")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" And, remembering that she still had a very, very long way to go, she wished Jules all the best and took off again, but she couldn’t stop thinking about why humans wanted to collect birds like her and stop them from living their normal lives in the trees.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("By now, it was getting very late, and she knew that sooner or later, she would need to find a safe place to stop for the night. The countryside below her had become much more interesting with rolling hills, rivers and forests. And so, this time, as she descended, she felt more confident about finding a nice place to spend the night. And she was in luck, because she landed in a farmyard, with pigs, horses, and cows, and in particular, a nice stable full of hay, with lots of room around the roof space for a parrot to spend a warm and comfortable night. So she settled down for the night, feeling cosy, sleepy, safe, and surrounded by rich farmyard smells.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("The next morning, however, she heard the sounds of a human coughing and spluttering. ‘Well, what ’ave we ’ere?’ a big, deep voice shouted. Well, actually he said it in French, saying, ‘Qu’est-ce que c’est que ca?’, because she was in France, after all.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Blow me if there ain’t a parrot in me barn.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rita was unsure whether she was in danger or not, but the man had a kind face and seemed to be the sort of person who respected animals and birds.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Come down here, my lovely, and let’s have a good look at you.’ So Rita plucked up her courage and flew down to the floor of the barn.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Come here and have something to eat,’ said the farmer, ‘and don’t be afraid. No one’s going to hurt you here.’ Gradually, all the pigs, horses, and cows began to wake up, and the farmer moved around the barn, handing out all the favourite things that pigs, horses, and cows like best for breakfast. ‘But for you, my beauty, come and sit on my arm, and I’ll take you to the house for a real treat.’ Rita liked this man and felt confident enough to jump up onto his arm. And off they went, across the farmyard and into the kitchen.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Sacre bleu, Jacques,’ said the farmer’s wife, as he entered the kitchen, ‘what have you got there?’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Well, we have a very special guest today, who needs a good breakfast because I think that he will soon want to continue on his journey.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘I think she’s a girl parrot, Jacques,’ said the farmer’s wife, and turning to Rita, asked, ‘what’s your name, darling?’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rita knew just enough about the human voice to answer, ‘Rita, madame.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Lovely name, dear,’ said the Farmer’s wife, whose name was Edith. ‘Let me go and fix you up with a bowl of something nice and tasty.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘I wonder what she’s doing down here in Provence,’ said Jacques.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Well, she’s obviously migrating south, like all those other birds,’ said Edith. And Rita nodded, as she was nibbling her slices of apple. After all, she had understood a bit of French from the Nincompoops’ cleaning lady.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Okay, young lady,’ said Edith, ‘you’re welcome to stay here as long as you want, but my guess is that you want to be on your way. So here’s my advice. There’s a strong wind blowing towards the south, called the Mistral. You’ll be flying along with it, so keep going until you arrive at the sea that we call the Mediterranean. Then things will calm down a bit for you, but you’ll have some choices to make that we can’t help you with. But you seem to have a strong character, and I’m sure you’ll get to wherever you want to be going.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("But I’m not sure where I should be going,")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" thought Rita, even though she was very appreciative of the hospitality that had been shown to her on the farm. She managed to squeak out a ‘merci beaucoup’, and then marched out into the courtyard. It was another beautiful day, and she felt rested and happy, as she spread her wings and found a warm current of air, lifting her up high above the Provençal countryside. ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("So far so good,")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" thought Rita, as she cruised along on the tailwinds of the Mistral, and into her next adventure.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer020"
    }
  }, [_c('p', {
    staticClass: "Image-on-next-page- ParaOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/1684919901_Rita-interior-V2_(4)_Page_34.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "main-heading"
  }, [_vm._v("Chapter 4")]), _vm._v(" "), _c('p', {
    staticClass: "sub-heading"
  }, [_vm._v("La Dolce Vita")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("As she headed further and further southwards, Rita had time to reflect on the last couple of days and what might lie ahead. So she said to herself, ‘I am a parrot, heading to where my parents came from, but I’d better stay careful because these humans seem keen to capture birds like me and lock them away in cages.’ But she’d done pretty well so far, I think we’d all agree. And so, as she came upon yet another stretch of water, aquamarine blue this time, she felt confident about the next stage of her journey. She noticed that the weather was getting warmer and warmer, and this felt good. But rather than fly on for miles over the Mediterranean, she decided to stay closer to the land, which now was Italy, and so several hours later, she landed on a tower that was leaning over at a slightly unusual angle. ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Well, I’ve sat on some strange perches, thought Rita, but I wonder whether this one is about to fall down.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("And once again, she noticed below her dozens of humans, all taking photographs. ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Why can’t they just enjoy these beautiful places, without having to photograph everything? she thought, and what will they ever do with all their photos when they get home?")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Just then, as she was wondering why some humans were so stupid, a pair of hawks landed next to her on the tower.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Ciao,’ the first one said, ‘we don’t get many parrots here in Pisa. Are you on your way somewhere?’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rita was a little unsure as to whether these hunting birds were friendly or not, but giving them the benefit of the doubt, said, ‘Well, yes. I’m just heading south to find the land that my parents came from.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Magnifico,’ said the hawk, ‘we’re also heading south, for a supper in Rome. I’m Luigi, and this is my wife, Gabriella. Come with us, we’ll show you the way.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Once again, Rita had struck luck and found new friends. So off the three of them went, up and over the countryside glowing in the late afternoon sunshine.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Now, down over there to the left,’ called Gabriella, as she led them towards a place that she seemed to know about. Rita followed them down to a lovely piazza, with old buildings on all sides.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘This is called Campo dei Fiori,’ said Gabriella, ‘and there are lots of leftovers from today’s market, so help yourself.’ She was right, there were scraps of fruit and vegetables everywhere. And so Rita helped herself to what she thought would be her dinner. Suddenly, from across the piazza and to her amazement, she saw a fellow parrot, grey all over but with red tail feathers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Buonasera, ma bella,’ said the grey parrot. ‘May I introduce myself? I am Marcello, and I am at the head of all the birds here in the Campo dei Fiori. You are very welcome here, and if I may say so, you are a very fine-looking parrot. Would you like to accompany me to dinner?’ Rita felt very shy. After all, she was in a strange country and didn’t know the local customs, or how best to respond.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("So she politely said, ‘Thank you very much, signor, but I don’t really know you at all.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Don’t worry,’ said Marcello, ‘I am a gentleman, as everybody knows around here. I will offer you a good dinner, and show you a comfortable place to spend the night. And then tomorrow, I will help you on your route.’ Well, this sounded pretty good to Rita, so how could she say no? ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘I’d be delighted to join you for dinner,’ she said, ‘just give me five minutes to get ready.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Bene,’ said Marcello, ‘meet me across the square at 8 o’clock.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Well, she couldn’t really say no to such a gentlemanly Roman parrot, could she? So off she went, looking for a big fountain to wash off all the dust that had gathered on her feathers. And what a fountain she found! It was huge, and all carved in green marble.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("She heard someone say that it was called ‘Trevi’. And even though there were masses of the usual tourists, all armed with their phone cameras, she still had plenty of space for a cool pre-dinner bath and then emerged to warm herself in the lovely evening sunshine. ‘What a beautiful city,’ she said to herself, as she got ready for her meeting with Marcello. The church bells rang out at 8 o’clock, and she swiftly flew back to the agreed meeting place.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Marcello was there, looking elegant and handsome. ‘Ciao bella,’ he said and indicated with a nod of his head a side street next to the restaurant. ‘Follow me this way, the cook is my friend.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("And there, in this small alley, was a table set for two, and in the middle of the table, a steaming plate of pasta.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘This is my favourite dish,’ said Marcello. ‘It’s called spaghetti aglio olio, and this is the best place in Rome to enjoy it.’ Rita settled down on the chair, opposite Marcello.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Thank you very much for making me feel so welcome in your city,’ she said, bowing her head ever so slightly.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘It’s nothing,’ replied Marcello, ‘but now just taste this lovely food.’ And that’s what Rita did.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Mmm,’ she said, ‘it’s delicious.’ So she ate more and more until there was hardly anything left, apart from a few last strands of spaghetti. She took one last bite and then found herself eye-to-eye with Marcello, who had picked up the same strand. She was embarrassed to find herself so close to this man parrot, and so dropped her end of the spaghetti.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Don’t worry, bella,’ said Marcello, ‘but now just tell me your story. Where do you come from, and where are you going?’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rita felt relieved, and so she told him everything.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Okay,’ said Marcello, ‘you’re doing the right thing to try and find your real home, and I respect you for that. I’m going to show you a safe, high place to spend the night, and then tomorrow, I’ll point out the direction to find Sicilia, where my brother lives. From there, he’ll be able to guide you towards the continent of Africa.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Thank you, Marcello,’ said Rita, ‘I’ve had a lovely meal tonight and you’ve been very kind to me. And I hope that I can meet you again one day.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘We’ll see,’ said Marcello, ‘but now it’s getting late, so follow me to my attic. My girlfriend and I will be sleeping nearby.’ At this point, Rita couldn’t believe how lucky she had been this far on her journey, having met kind and friendly humans and birds. But she still had a long way to go and would need all her wits about her to navigate the next stage.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Here we are,’ said Marcello, pointing to an old and uninhabited loft with open windows, ‘you can sleep anywhere you want. And tomorrow, I’ll tell you how to find my brother in Sicilia.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rita settled down for the night, with a full stomach, and a contented feeling. She even thought about staying here in Rome, but, deep down, she knew that she had to continue, to find the place where her parents had lived before their capture. With all these thoughts running around her head, drowsiness gradually came over her, and she fell into a deep, deep sleep, dreaming of the Nincompoops, the ferry and the towers in France and Italy.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("She was awoken in the morning, by a sharp ray of sunlight coming through the open window.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Come on, wake up, it’s another beautiful day,’ called Marcello, ‘come and meet my girlfriend.’ Rita shook herself awake and waddled down to the floor below, where Marcello and his girlfriend, Viola, were waiting for her.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Buongiorno, Rita,’ they both said and pointed to a table where there was a plentiful collection of figs, bananas and peanuts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Eat up,’ said Marcello, ‘and while you eat, I’m going to explain how to find my brother who lives on the island of Sicilia, in a place called Agrigento. He’s been to Africa several times and will be able to give you important information for the final stage of your journey. He’s a grey parrot, like me, but not nearly so handsome.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Viola gave him a peck, and Rita laughed. ‘Don’t believe him,’ said Viola, ‘his name is Nino, and he is just as handsome as Marcello, just a bit older.’ Marcello then told Rita which way to fly out of Rome, which once again, involved flying south in a straight line, following the warm winds.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘And now,’ said Viola, ‘we wish you all the best of luck on your")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer022"
    }
  }, [_c('p', {
    staticClass: "Graphics",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-6",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035843466_txt16.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer023"
    }
  }, [_c('p', {
    staticClass: "Txt"
  }, [_vm._v("journey, but please promise to come back and visit us again in Rome someday. We will always welcome you here.’")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rita was once again overcome by the kindness and friendliness of these two, and said, ‘I don’t know how to thank you, but one day, I hope I’ll be able to pay you back. But now, I need to be on my way.’ And with that, she pecked them both on their cheeks and headed out of the open window, high above the beautiful skyline of Rome.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Well, the next part of her journey followed the beautiful sunlit coastline and passed without incident. She flew high over the Mediterranean Sea, marvelling at the beautiful colours, while thinking to herself that they resembled the bright colours of her own plumage. ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("It’s tempting to just stay here, ")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("she thought, but her sense of determination drew her on, further and further south, until she was above the island of Sicily. She remembered that Marcello’s brother lived on the south coast of the island among some ancient Roman temples, so on and on she glided until she spotted a long line of ruins stretching up a hillside.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("As she hovered over the landscape looking for a place to land, she heard a voice calling ‘Rita, Rita’. And there down below was a grey parrot, exactly as Marcello had described. ‘Come on down, it’s me, Nino. My brother sent me a message by pigeon post last night, and I’ve been expecting you.’ Rita landed to meet Nino in the middle of an ancient Roman temple, surrounded by beautiful golden columns.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Pleased to make your acquaintance,’ said Nino, who looked just like an older version of Marcello. ‘How are things in Rome?’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Just lovely,’ replied Rita, ‘and your brother was extremely kind to me.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Splendid,’ said Nino. ‘Well, I’ve been to Africa a few times, and I think I can help you on your way. But Africa is a very big place, so do you have any idea which part of it you want to go to?’ Rita didn’t know at all and began to feel a bit hopeless, but then she remembered a story that her parents told her, about a jungle and a tribe of elephants who lived near to a huge lake.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Hmm, I think I know where that is,’ said Nino, ‘but you settle down here for the night while I go and talk to some of my friends to see what they think. I’ll be back at sunrise.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rita nibbled on a few olives and then settled down to yet another sleepy night, surrounded by salty sea air and the sweet smell of lemons and oranges. ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Nearly there,")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" she thought, as sleep crept over her. True to his word, the next morning at dawn, there was Nino accompanied by a much older parrot, whose colours were the same as hers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Well, young lady,’ began the older parrot, ‘it’s been many years since I’ve seen one of your kind, in fact, one of our kind in this part of the world. But now, listen carefully, while I tell you how to find other birds like you and me.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘The African country that you need to head for is called Mozambique. It’s on the East Coast, and it’s very beautiful. That’s where I believe you’ll find members of your family.’ And he pointed to a map on the visitor’s board of the temple, to give her a rough idea of where Mozambique was, in relation to Europe and the rest of the African continent.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Right then,’ said Rita, ‘that’s good enough for me. I’d better get going now, but thank you a hundred times for helping me out. I’ll never forget you and your brother. And if Mozambique doesn’t suit me, I’ll certainly come back to Italy.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Buon viaggio,’ replied Nino, ‘and do come back and see us one of these days.’ Rita then did a few warming-up exercises, and then spread her wings, and headed off over the Mediterranean, and kept going, and going, and going…")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer025"
    }
  }, [_c('p', {
    staticClass: "Image-on-next-page- ParaOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/1684919901_Rita-interior-V2_(4)_Page_34.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "main-heading"
  }, [_vm._v("Chapter 5")]), _vm._v(" "), _c('p', {
    staticClass: "sub-heading"
  }, [_vm._v("Nearly There")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Flying on and on was very tiring, but at least she had the company of many other birds migrating southwards – swallows, ducks, geese and even swans – so she had plenty of time to chat as she flew. The bird that she chatted to the most was a handsome blue swallow who, as they flew, introduced himself as Sylvain, and gave her a very useful piece of advice.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Africa is a huge continent, and if you’re really thinking of going all the way to Mozambique, you should jump on the back of a lorry going in that direction. In Tunisia, where I’m heading, there are plenty of lorries heading that way, and I’d be happy to show them to you.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("This seemed like a good idea, to Rita, and so she flew with the swallows across the Mediterranean, to the coast of North Africa. As they landed in Tunis, Sylvain said, ‘Okay, come with me, and I’ll show you where the lorries will be leaving early tomorrow morning.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rita followed him to a huge car park, on the edge of town, where dozens of lorries were parked.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘I suggest you take that one,’ said Sylvain, ‘it’s open at the back, and you’ll be able to enjoy all the fresh air on the way to Mozambique.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Not for the first time, Rita graciously thanked her new friend, and snuggled down on the back of the lorry, amongst the sacks of spices and drums of olive oil.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Nearly there, she thought. But just at that moment, Sylvain said, ‘You know what, I think I’ll come with you. I’ve always wanted to see Mozambique.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Great,’ said Rita, ‘I’ll be happy to have your company, as long as there are no distractions. Because my number one purpose is to find my family home.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Understood,’ said Sylvain, ‘and I’d be delighted to help you on your way.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rita awoke at dawn to the noise of the lorry engines all starting up at the same time. And what a noise it was, along with men shouting at each other in all directions.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Don’t worry,’ said Sylvain, ‘it’s always like this, and it’ll be fine once we’re out on the open road.’ Before long, all the lorries trundled off, heading for different parts of the African continent.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Told you so,’ said Sylvain, ‘now just get comfortable, and be patient because this journey will take us about six days. So, in the meantime, tell me a bit about yourself.’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("So Rita told him everything, about her life in England with the Nincompoops, how she had escaped, her adventures in Europe, and, her hopes for the future. And this took several days, because they got on really well together, and both of them had a lot to say about themselves. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Once Rita had told him everything, Sylvain said, ‘Wow, what a story! I’ve never met such a courageous bird. But do you really think you’ll be able to find your family members? And then, even if you do, will you be able to adapt to life in the African jungle?’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘I don’t know yet,’ replied Rita, ‘but I’m certainly going to give it a try. We parrots weren’t meant to live in cages, just for the pleasure of humans. And with a bit of luck, that’s to say, if I meet other birds as friendly as those I’ve met so far, things should turn out just fine.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("She said this with bravado, although deep down, she was starting to feel a bit nervous about what sort of welcome she would receive in Mozambique. After all, she had lived a very different life up to this point, being fed by the humans, and had never had to face up to dangerous predators. And more than that she would be arriving as a complete stranger. It wasn’t going to be easy.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("But for now, things were going just fine. She had a comfortable place to sit on the back of the lorry and was enjoying all her chats with Sylvain. Until, around lunchtime on the fifth day, the lorry screeched to a sudden stop. Rita poked her head round the side, and saw that the road was blocked by another car, and standing in front of it was a man with a gun.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Get out now,’ said the man to the lorry driver, ‘give me your keys, and lie down in the road.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Okay,’ said the lorry driver, whose name was Django, ‘I don’t want any trouble.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Keep quiet then,’ said the man with the gun, ‘and drop your phone. I just want this full truckload of olive oil and spices, and you’re going to give it to me.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rita had watched all this happening from the back of the truck and had fluffed up her feathers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Don’t do anything reckless,’ said Sylvain, ‘it’s none of our business really.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("But Rita had other ideas. She quietly moved down the other side of the lorry until she was just behind the man with the gun. Then she jumped up and gave him a strong peck on the end of his nose. The bandit was so surprised that he dropped his gun, which was quickly grabbed by Django.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Right then,’ said Django, ‘looks like things have changed, thanks to this stowaway parrot, that I didn’t even know was there. So it’s my lucky day. But you, young man, take your car and drive far away from here, stop robbing lorries, and try and live a better life.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("The bandit did as he was told, and sped off in a cloud of smoke. Django then turned to Rita.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘How can I thank you?’ he said. ‘You’ve saved my lorry and my life.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Well, he was a bad man,’ replied Rita, ‘and he wasn’t expecting to be attacked by a parrot, so I just did what I had to do.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘You’re very brave,’ said Django, ‘not many people, not to mention animals or birds, would have done what you did. You’re now my guest. Come and sit up front with me, and tonight, we’ll have a lovely barbecue under the stars, you, me and, your friend.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("So the lorry continued on and on, along dusty and bumpy roads, which caused the big drums of olive oil to rattle together, stopping the birds from having their afternoon siesta.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘We’ll stop when it gets dark,’ said Django, ‘and then I’ll make a fire, and well have a lovely feast from all the things my wife packed for me.’ Little by little, the sun dropped lower and lower in the west and lit up the sky in a kaleidoscope of purple, pink, orange, and gold.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Right, this is it,’ said Django, bringing the lorry to a stop just off the main road. ‘Now, what I’d like you two to do is to go off and")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer027"
    }
  }, [_c('p', {
    staticClass: "Graphics",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-3",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035843466_txt20.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer028"
    }
  }, [_c('p', {
    staticClass: "Txt"
  }, [_vm._v("gather some small sticks, so that I can start our fire, and then get cooking.’")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("This was a simple task for Rita and Sylvain, and after a few short flights into a nearby wood, they had enough sticks to get the fire going.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Grilled peaches, bananas and aubergines for you two, and a nice piece of fish for me,’ said Django, as the flames of the fire lit up their surroundings.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rita looked up at the sky and saw hundreds of shimmering stars. And the more she looked, the more stars appeared, some in clusters, some making shapes. And occasionally, one would shoot through the sky, going who knows where. As she tucked into the delicious meal that Django had prepared, she felt a deep sense of happiness, confident that she was on the right path to a new and better life.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("The next day, after another long day’s driving, during which Sylvain had explained what it was like to be a swallow, darting around at speed, they finally crossed into Mozambique.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘I have to go all the way to the main city,’ said Django, ‘but in about an hour, we’ll be arriving at the edge of the jungle, which is where I think you want to go if you’re going to join up with your fellow parrots.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rita looked at Sylvain and fell silent for the next hour. She knew that the end of her journey was approaching and that a new chapter, a new challenge, would then present itself. The scenery gradually became darker, as the road passed through a tunnel of tall, dark green palm trees, and the air was full of animal screeching of all kinds. Django brought the lorry to a halt at the side of the road.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Okay, no crying,’ he said, ‘you’ve already proved how brave and adventurous you are, and I just know that you’ll be able to survive here, even if it will be difficult at first. My only advice is to quickly find a friend who will help you adjust to your new surroundings, and point you towards your parrot family.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘That’s right,’ added Sylvain, ‘I’ve never met a bird with as much character as you. If anyone can make it here, then you can.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘I wouldn’t have been able to get here without help from you both,’ replied Rita.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘That’s alright,’ said Django, ‘but now I have to get going to meet my delivery deadline. It’ll soon be dark, and predators will be on the prowl. So you go and find a big high tree to spend the night, and then tomorrow, have a good look around and make a plan. And don’t worry, Rita, everything will work out fine.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Then he started up the engine of the lorry, and carried on along the road, taking Sylvain with him. Rita followed his advice and found a tall tree, covered in big leaves where she couldn’t be seen. She was on her own again and wondered how she would manage the next day, but thought to herself that she had once again shown that she could deal with all sorts of new situations. And with these mixed thoughts running around her head, she fell into a deep sleep.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer030"
    }
  }, [_c('p', {
    staticClass: "Image-on-next-page- ParaOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/1684919901_Rita-interior-V2_(4)_Page_34.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "main-heading"
  }, [_vm._v("Chapter 6")]), _vm._v(" "), _c('p', {
    staticClass: "sub-heading"
  }, [_vm._v("Home at Last")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("At dawn the next morning, she was awoken by a loud, rhythmic thumping noise. And the tree that she was sleeping in actually began to shake.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("What on earth,")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" she thought, and looked down on a herd of elephants, all marching in line.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("She tried to gather her thoughts, and concluded first, that elephants were probably friendly, and that she was probably safe. Secondly, she remembered that elephants lived long lives, and perhaps one of them would be able to help her find the place that her parents had come from. Yes, Rita was a quick thinker. So she waited until all the biggest elephants had passed, and then flew down to land on the back of the smallest elephant, who was at the back of the line.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Hello, I’m Rita,’ she announced, ‘can I come along for the ride?’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Yes, you’re very welcome, and very pretty, if I may say so,’ replied the young elephant, ‘and my name is Liam. What are you doing around here? I’ve never seen a parrot on any of our dawn marches.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("As they bounced forward, Rita told Liam her story about how she had arrived here.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘That’s unbelievable,’ said Liam, ‘I tell you what. At the next bend, you fly off and hide, and when I get to our home by the big lake, I’ll tell your story to my parents, and grandparents, and I’ll ask them if you can come and stay with us for a few days. They’re all very kind, and I’m sure one of them will know the part of the jungle that parrots like you live in.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Thanks so much, Liam,’ said Rita, ‘I’ll wait by the bend in the road until sunset, and if you don’t come by then, I’ll know that I need to find another solution.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("The line of elephants then turned sharply left, and Rita jumped off Liam, and into a tall coconut tree. And then she waited and waited, and waited.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("So, if he doesn’t come back, I’m on my own, she thought, and if he does, then I have a chance. So will he or won’t he? It’s probably 50/50,")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" she thought, suddenly remembering Mr Nincompoop’s fondness for betting on this and that. But just as the sun was going down, she saw Liam heading towards her, accompanied by a much bigger elephant, whom she assumed was his father.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("As they got nearer, the big elephant said, ‘Hello, Rita. Liam has explained everything. Of course, you can come back with us.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Come on,’ said Liam, ‘you can ride on my back.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Relieved, Rita jumped down onto Liam’s back, and off they trundled, to the edge of a village where all the elephants lived. They were met by Liam’s mother.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Welcome, welcome,’ she said, ‘I’m Winnie. And supper is almost ready. Then we’ll have a nice chat and get to know one another.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rita was the guest of honour that evening.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Now then,’ said Winnie, ‘help yourself to whatever you want from what I’ve prepared, and then tell us more about yourself.’ Rita ate hungrily and then looked up at the elephant family.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Thank you so much for supper, and for letting me stay with you, but I really need to ask you about my parents, and the rest of my family. Do you have any idea what happened to them?’ Liam’s father snorted and began to speak.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Prepare yourself, Rita,’ he said, ‘because it’s a sad story.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Go on,’ she replied, ‘I’m ready.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Well then,’ began Liam’s father, ‘about ten years ago, a group of hunters came to this part of our jungle. They were after anything, crocodile skins, elephant tusks, and exotic birds, and unfortunately, this included your mother and father. They were a lovely couple, kind and friendly, but they were trapped by the hunters, and we never saw them again. A few of the parrots escaped however, and moved to another part of the jungle, but I’m sorry to say that I don’t know where they went.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rita was filled with sadness. Had this whole journey been for nothing?")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Wait a minute,’ grumbled one of the older elephants who was Liam’s grandfather. ‘I heard from one of our giraffe neighbours that the parrots moved to a place deeper into the jungle about one hour from here. If you’re up for it, Rita, we can set off tomorrow morning to try and find them.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Yes, yes, yes!’ shouted Rita. ‘I’ll be ready.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("At sunrise the next morning, the three of them set off – Liam, his grandfather and, of course, Rita.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘My giraffe friend told me that the parrots had moved to the west,’ said Liam’s grandfather, ‘but be sure to stay on this path, because there are lots of lions and leopards in this part of the jungle. They won’t attack me, because they know me, but stay close anyway.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("After a bit more than an hour of tramping through the jungle, Rita heard familiar sounds above her head. ‘I think we’re getting close now,’ she said nervously. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Be patient,’ replied Liam’s grandfather, ‘we still have a bit further to go.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Suddenly, a nasty-looking snake appeared in front of them, hissing with menace, and saying, ‘Go home, thisss iss my territory.’ But Liam’s grandfather just moved slowly forward and stamped on the snake.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘I hate snakes,’ he muttered.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Ten minutes later they came to a clearing, in the middle of which was a muddy pool, where three hippopotamuses were having their morning bath.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Well, here we are,’ said Liam’s grandfather, ‘now we just have to wait.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("But they didn’t have to wait for long, because just to their left on the branch of a tree, was a parrot whose plumage was very much like Rita’s.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Good morning, friends,’ she called out, ‘and welcome to our part of the jungle. What can I do for you?’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘I’ve brought someone who I think you might want to meet,’ replied Liam’s grandfather, as Rita edged out from behind his big left ear, and said, ‘Hello, I’m Rita.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Well, knock me down with a feather, but you look just like my sister, who was captured here ten years ago. Her name was Gina. Do you know anybody by that name?’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘She was my mom,’ said Rita, feeling tears coming into her eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘So you are really Gina’s daughter!’ she shouted. ‘But that’s unbelievable. How on earth did you find your way here?")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Well, with a lot of determination, and with the help of some wonderful friends,’ replied Rita, choked with emotion. ‘Friends like these,’ she said, turning to Liam and his grandfather. ‘I’m home now, and I can’t thank you enough for helping me find my family. But now, we’ll be neighbours, and I’ll see you often.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Yes,’ replied Liam, ‘pop over and see us whenever you want, and you’ll be able to fly much faster than we can walk. So see you very soon.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With that, the elephants turned around and slowly began their return journey.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Come on then, follow your Aunt Olive, and I’ll take you to meet your cousin. Her name is Tina, and she’s about two years older than you. You’ll become just like sisters, I’m sure.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Olive led the way, flying swiftly through a tangle of branches, and Rita, following behind had to be careful not to lose sight of her. Before long, they came to a place where the trees were taller than any other trees in the jungle. And in the trees, there were dozens and dozens of parrots, sitting in pairs, on the various branches, with the younger smaller ones towards the bottom, and the elders at the top.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Listen everyone,’ squawked Olive, ‘today is a very special day. I want to introduce you all to Rita, the daughter of Gina, who was captured by those bad men all those years ago. And guess what, she has made her way back here all the way from England, where she has been kept captive! So let’s show her a proper Mozambique parrot welcome.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("All the parrots gathered around Rita, chattering excitedly.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘How did you find us?’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Are you hungry?’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Do you want a bath?’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Tell us about England.’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Have you got a boyfriend?’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rita was overwhelmed, and simply said, ‘Give me some time, and I’ll answer all your questions. For now, I’m just so happy to have found you all.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("And then a girl parrot, just a bit bigger than Rita, pushed her way through the crowd and stood facing Rita.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("‘Hello, Cousin,’ she said, ‘I’m Tina, and I’m going to take care of you from now on. And we’re going to have some fantastic adventures together.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer032"
    }
  }, [_c('p', {
    staticClass: "Graphics",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-4",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035843466_txt25.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer034"
    }
  }, [_c('p', {
    staticClass: "Image-on-next-page- ParaOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-7",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/1684919901_Rita-interior-V2_(4)_Page_341.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "main-heading"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The End")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23a129ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781035843473_Epub.vue
// module id = 57
// module chunks = 0